import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../axiosInstance";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const MyEvents = () => {
  const { t, i18n } = useTranslation();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";

  useEffect(() => {
    AOS.init({ duration: 1000 });
    fetchRegisteredEvents();
  }, []);

  const fetchRegisteredEvents = async () => {
    try {
      const res = await axiosInstance.get("/api/v1/users/events/registered");
      console.log("Fetched events:", res.data);
      setEvents(res.data?.items || []);
    } catch (error) {
      console.error("Error fetching events:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-5" dir={languageDirection}>
      <h2 className="mb-4 text-center text-warning">{t("my_events")}</h2>

      {loading ? (
        <div className="text-center my-5">
          <div className="spinner-border text-warning" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : events.length === 0 ? (
        <div className="alert alert-warning text-center">
          {t("no_registered_events")}
        </div>
      ) : (
        <div className="row">
          {events.map((item) => {
            const event = item.event;
            if (!event) return null;

            const eventDate = moment(event.eventOn);
            const day = eventDate.format("D");
            const month = eventDate.format("MMM");
            const location = event.isOnline
              ? t("online")
              : event.city || t("no_location");

            return (
              <div
                className="col-md-6 col-lg-4 mb-4"
                key={item.id}
                data-aos="fade-up"
              >
                <div
                  className="card event-card shadow-sm h-100 position-relative"
                  onClick={() => {
                    if (!event?.id) {
                      console.warn("Missing event ID");
                      return;
                    }
                    navigate(`/event-detail/${event.id}`);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <div className="position-relative">
                    <img
                      src={event.bannerUrl}
                      alt={event.name}
                      className="card-img-top"
                      style={{ height: "200px", objectFit: "cover" }}
                    />
                    <div className="position-absolute top-0 end-0 m-3">
                      <div className="event-date text-center bg-light px-2 py-1 rounded">
                        <small className="text-muted">{month}</small>
                        <div className="fw-bold">{day}</div>
                      </div>
                    </div>
                  </div>

                  <div className="card-body">
                    <h5 className="card-title fw-bold">{event.name}</h5>
                    <p className="card-text text-muted">
                      <i
                        className={`fas ${
                          event.isOnline ? "fa-video" : "fa-map-marker-alt"
                        } me-2`}
                      ></i>
                      {location}
                    </p>

                    {/* <div className="d-flex align-items-center mt-3">
                      <img
                        src={
                          event.organizer?.profileImage ||
                          "/assets-v2/images/default-user.png"
                        }
                        className="rounded-circle me-2"
                        alt={event.organizer?.arabicFullName || ""}
                        width={40}
                        height={40}
                      />
                      <div>
                        <small className="text-muted">
                          {t("events_main_speaker")}
                        </small>
                        <p className="mb-0 small fw-medium">
                          {event.organizer?.arabicFullName}
                        </p>
                      </div>
                    </div> */}
                  </div>

                  <div className="card-footer bg-transparent border-0 pb-3 d-flex gap-2 flex-column">
                    <button
                      className="btn btn-sm btn-outline-primary w-100"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        if (!event?.id) {
                          console.warn("Missing event ID");
                          return;
                        }

                        console.log("View details of", event.id);
                        navigate(`/event-detail/${event.id}`);
                      }}
                    >
                      <i className="fas fa-eye me-1"></i>
                      {t("view_details")}
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MyEvents;
